import {
  getModule,
  Module,
  Action,
  Mutation,
  VuexModule
} from 'vuex-module-decorators';
import store from '@/store';

import { LoadingModule } from '@/types/modules/LoadingModule';

@Module({
  name: 'loading',
  dynamic: true,
  namespaced: true,
  store: store
})
class LoadingModuleImpl extends VuexModule implements LoadingModule {
  public loading = false;

  @Mutation
  setLoading(loading: boolean): void {
    this.loading = loading;
  }

  @Action
  startLoader(): void {
    this.setLoading(true);
  }

  @Action
  dismissLoader(): void {
    this.setLoading(false);
  }
}

export default getModule(LoadingModuleImpl);
